import type { Component } from 'vue';

const load = () => import('./ui/index.vue');

export const DateTimeModal: Component = defineAsyncComponent(() =>
  load().then((m: { default: Component }) => m.default),
);

export const prefetchDateTimeModal = (): void => {
  load().catch(() => null);
};
